import React, { useState, useEffect, useContext, useCallback } from "react";
import SideMenuContext from "../context/sideMenuContext";
import CreateProjectForm from "./forms/createProjectForm";
import {
  createNewProject,
  getDynamicFieldsFromMenuForCreateNew,
  getProjectByNumber,
  getProjectType,
  deleteProject,
} from "../services/uiService";

import toast, { Toaster } from "react-hot-toast";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ProjectDetailForm from "./forms/projectDetailForm";
import { useParams, useLocation } from "react-router-dom";
import { createProjectThunk } from "./../redux/createproject/createProjectThunk.js";
import { useDispatch, useSelector } from "react-redux";
import { getprojectByNumberThunk } from "./../redux/projectlist/projectListThunk";
import ModalComponent from "./modal/modalComponent";
import { Button } from "react-bootstrap";
import MapiToolbar from "./toolbar/MapiToolbar";

const formatStringToDate = (inputString) => {
  if (!inputString || isNaN(new Date(inputString))) {
    return null;
  }
  const date = new Date(inputString);
  return date.toISOString().split("T")[0];
};

const ProjectDetails = (props) => {
  const [fieldItems, setFieldItems] = useState([]);
  const { projectId } = useParams();
  const location = useLocation();
  const history = useHistory();
  const [preProjectData, setPreProjectData] = useState();
  const [projectIdFromResponse, setProjectId] = useState();
  const [isProjectCreatedFailedModal, setIsCreatedFailedModal] =
  useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  
  const dispatch = useDispatch();
  const projectResult = useSelector((state) => state?.project?.NewProject);
  const checkIsProjectIdExist = useSelector((state) => state);

  const OneProjectRecord = useSelector(
    (state) => state?.projectList?.fetchList
  );
  
    const parseDDMMYYYY = (str) => {
    const [day, month, year] = str.split("/");
    return new Date(`${year}-${month}-${day}`);
  };
  
  function getDateDDMMYYYY() {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');

  const day = pad(now.getDate());
  const month = pad(now.getMonth() + 1);
  const year = now.getFullYear();

  return `${day}/${month}/${year}`;
}

  const transformData = (data) => {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        value !== "" ? (key === "UpdatedDate" || key === "CreationDate" || key === "updatedDate" || key === "creationDate") ? parseDDMMYYYY(value) :  value : null,
      ])
    );
  };

  const fetchMenuFieldsWithProjectOptions = async () => {
    try {
      const [fields, projectOptions] = await Promise.all([
        getDynamicFieldsFromMenuForCreateNew(props.generalEndPoint, 5),
        getProjectType(props.generalEndPoint),
      ]);

      const typeMapping = {
        Text: "text",
        Date: "date",
        Dropdown: "select",
        Number: "number",
        TextArea: "textarea",
      };

      const optionsField = projectOptions.map((option) => ({
        value: option.id,
        label: option.name,
      }));
      const updatedFields = fields.map((field) => ({
        name: field.id,
        label: field.title,
        type: typeMapping[field.typeName]?.toLowerCase() || "text",
        isDisabled: field?.id === "ProjectNumber" ? true : field.disabled,
        isRequired: !field.allowNull,
        options: field.typeName === "Dropdown" ? optionsField : [],
        sequence: field.index_,
      }));

      setFieldItems(updatedFields);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const onClickSubmitForm = useCallback(
    async (
      values,
      validateForm,
      setTouched,
      shouldRedirect,
      resetForm,
      preData
    ) => {
      setTouched(
        Object.keys(values).reduce((acc, key) => ({ ...acc, [key]: true }), {})
      );

      const userDataString = sessionStorage.getItem("userData");
      let displayName = "";

      if (userDataString) {
        const userData = JSON.parse(userDataString);
        displayName = userData.user.displayName; 
        values["UpdatedBy"] = displayName
        values["updatedDate"] = getDateDDMMYYYY();
      }

      const errors = await validateForm();
      if (Object.keys(errors).length === 0) {
        try {
          const payload = {
            ...transformData(values),
            projectID: projectIdFromResponse!==undefined ? projectIdFromResponse: preData.projectID,
          };
          await dispatch(
            createProjectThunk({
              endpoint: props.generalEndPoint,
              payload: payload,
            })
          );

          //remove, this is for create project
          // if (!projectResult?.succeeded) {
          //   toast.error(".הפרויקט כבר קיים");
          //   return;
          // }

          const updatedFieldItems = fieldItems.map((item) => {
            if (item.type === "date") {
              return {
                ...item,
                value: formatStringToDate(projectResult?.project?.[item?.name]),
              };
            }
            return {
              ...item,
              value: projectResult?.project?.[item?.name] || null,
            };
          });
          setFieldItems(updatedFieldItems);
          if (projectResult?.message) {
            if (shouldRedirect) {
              sessionStorage.setItem("sessionID", "");
              history.push("/home/intake", { data: values, preData: preData });
            }
          }
        } catch (error) {
          setIsCreatedFailedModal(true);
          resetForm();
        }
      }
    },
    [fieldItems]
  );

  const onClickCloseForm = useCallback(
    (resetForm) => {
      resetForm();
      localStorage.clear();
      history.push("/home");
    },
    [fieldItems]
  );

  const fetchProjectDetails = async () => {
    //const response = await getProjectByNumber(props.generalEndPoint,projectId);
    dispatch(
      getprojectByNumberThunk({
        endpoint: props.generalEndPoint,
        projectNumber: projectId,
      })
    );

    // setProjectId(response.project.projectID);
    // const formatDate = (dateString) => {
    //   const date = new Date(dateString);
    //   const day = String(date.getDate()).padStart(2, "0");
    //   const month = String(date.getMonth() + 1).padStart(2, "0");
    //   const year = date.getFullYear();
    //   return `${day}-${month}-${year}`;
    // };
    // const formattedData = {
    //   ...response.project,
    //   creationDate: formatDate(response.project.creationDate),
    //   updatedDate: formatDate(response.project.updatedDate),
    // };
    // setPreProjectData(formattedData);
    // const formatDate=()=>{

    // }

    //remove the formattedData from here
    // const formattedData = {
    //   ...response.project,
    //   creationDate: formatDate(response.project.creationDate),
    //   updatedDate: formatDate(response.project.updatedDate),
    // };
  };

  //add useeffect for testing
  //console.log("preProjectData", preProjectData);

  useEffect(() => {
    if (OneProjectRecord && OneProjectRecord.project && OneProjectRecord.project.projectNumber === projectId) {
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };

      const formattedData = {
        ...OneProjectRecord.project,
        creationDate: formatDate(OneProjectRecord.project.creationDate),
        updatedDate: formatDate(OneProjectRecord.project.updatedDate),
      };

      setPreProjectData(formattedData);
      setProjectId(OneProjectRecord.project.projectID);
    }
  }, [OneProjectRecord]);

  useEffect(() => {
    //console.log("OneProjectRecord ", OneProjectRecord);
  }, [OneProjectRecord]);

  useEffect(() => {
    fetchProjectDetails();
    localStorage.setItem("routeActive", "listproject-route");
    fetchMenuFieldsWithProjectOptions();
    setPreProjectData(location.state?.data);
  }, []);

  useEffect(() => {
    fetchProjectDetails();
  }, [!projectIdFromResponse]);

  const handleDeleteProject = () => {
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setIsDeleting(true);
      await deleteProject(props.generalEndPoint, projectId);
      setShowDeleteModal(false);
      history.push("/home/projects");
    } catch (error) {
      console.error("Error deleting project:", error);
      setShowDeleteModal(false);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <SideMenuContext.Consumer>
        {({ isSelectedMenu }) => {
          return (
            <>
              {fieldItems.length > 0 && (
                <ProjectDetailForm
                  preData={preProjectData}
                  fields={fieldItems}
                  generalEndPoint={props.generalEndPoint}
                  onClickCloseForm={onClickCloseForm}
                  onClickSubmitForm={onClickSubmitForm}
                  onDelete={handleDeleteProject}
                  isDeleting={isDeleting}
                />
              )}
              <Toaster position="top-left" reverseOrder={false} />
            </>
          );
        }}
      </SideMenuContext.Consumer>
      
      <ModalComponent
        show={isProjectCreatedFailedModal}
        onHide={() => setIsCreatedFailedModal(false)}
        title=""
        bodyContent={<p>השמירה נכשלה</p>}
        footerContent={
          <>
            <Button onClick={() => setIsCreatedFailedModal(false)}>
              סגירה
            </Button>
          </>
        }
      />
      <ModalComponent
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        title=""
        bodyContent={<p>?האם אתה בטוח שברצונך למחוק את הפרוייקט</p>}
        footerContent={
          <>
            <Button onClick={() => setShowDeleteModal(false)}>לא</Button>
            <Button onClick={handleConfirmDelete}>כן</Button>
          </>
        }
      />
    </>
  );
  };
export default ProjectDetails;
//with redux
